import React from 'react';

function NotApproved() {
	return <div>NotApproved</div>;
}

export default NotApproved;
